import {  Space, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";
import {
  ModalItem,
  ButtonItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import polizaSeguroPdf from "../../../../Pdf/polizaSeguroPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalPdfPoliza extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pdf: null,
    };
    this.formRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible) {
        this.consultarDatosPdf();
      }
    }
  }

  async consultarDatosPdf() {
    this.setState({ loading: true });
    axios
      .post(
        "/polizasSeguro/datosPdf",
        { polizaId: this.props.polizaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const generador = polizaSeguroPdf(res.data);
          const pdf = pdfMake.createPdf(generador);

          this.setState(
            {
              loading: false,
              pdf: pdf,
            },
            () => {
              pdf.open({}, window.frames["PolizaPdfIframe"]);
            },
          );
        } else {
          message.error("No se encontraron datos para la póliza");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error al generar el documento");
        this.setState({ loading: false });
      });
  }

  descargarPdf() {
    if (this.state.pdf) {
      const nombreArchivo = `Poliza_${this.props.polizaNumero || "Documento"}.pdf`;
      this.state.pdf.download(nombreArchivo);
    }
  }

  handleCancel = () => {
    this.props.onCancel();
  };

  render() {
    return (
      <ModalItem
        title="Vista Previa Póliza"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.handleCancel}
        paddingTop
        width={800} // Un poco más ancho para ver bien el PDF
        footer={null} // Quitamos botones default del modalItem si tiene
      >
        {/* Botones de Acción Superiores */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 10,
          }}
        >
          <Space>
            <ButtonItem
              icon={<DownloadOutlined />}
              type="primary"
              onClick={() => this.descargarPdf()}
            >
              Descargar PDF
            </ButtonItem>
            <ButtonItem danger onClick={this.handleCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>

        {/* El Iframe donde vive el PDF */}
        <iframe
          title={"Poliza PDF"}
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="PolizaPdfIframe"
          name="PolizaPdfIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalPdfPoliza);
